
    import React from 'react';
    import SpriteSymbol from "svg-baker-runtime/browser-symbol";
    import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
    import SpriteSymbolComponent from "../src/Icon.js";
    
    const symbol = new SpriteSymbol({
  "id": "plusko",
  "use": "plusko-usage",
  "viewBox": "0 0 240 80",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 240 80\" id=\"plusko\"><text x=\"86.311\" y=\"52.219\" style=\"line-height:0%\"><tspan x=\"86.311\" y=\"52.219\" font-size=\"17.36\" font-weight=\"500\" font-family=\"Soleil\" fill=\"#db002e\">Spojujeme</tspan><tspan x=\"86.311\" y=\"76.048\" font-size=\"17.36\" font-weight=\"500\" font-family=\"Soleil\" fill=\"#002e5f\">a podporujeme</tspan></text><circle cx=\"40.023\" cy=\"33.907\" r=\"33.119\" fill=\"#fff\" /><path fill=\"#db002e\" d=\"M24.786 32.798h30.448v2H24.786z\" /><path fill=\"#002e60\" d=\"M39.438 18.731h2v30.448h-2z\" /></symbol>"
});
    sprite.add(symbol);

    export default class PluskoSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="plusko" {...this.props} />;
      }
    }
  